import { IFederationForm, IFederationUser, IFederationUserApi } from '../models';
import { IFederationCreateFormApi, IFederationUpdateFormApi } from '../models/api';

export function mapToFederationUserItemModel(apiModel: IFederationUserApi): IFederationUser {
	return {
		...apiModel,
	};
}

export function mapToFederationCreateFormApi(model: IFederationForm): IFederationCreateFormApi {
	return {
		name: model.name,
		currencyCode: model.currencyCode,
		subsidiaryIds: model.subsidiaryIds,
		withCustomersAggregated: model.withCustomersAggregated,
		logo: model.logo.underlyingFile,
		brandingCode: model.brandingCode,
	};
}

export function mapToFederationUpdateFormApi(model: IFederationForm): IFederationUpdateFormApi {
	return {
		federationId: model.federationId,
		name: model.name,
		subsidiaryIds: model.subsidiaryIds,
		logo: model.logo.underlyingFile,
		isLogoDeleted: model.isLogoDeleted,
	};
}
